import { render } from "./document-category-list-modal.vue?vue&type=template&id=8d21764e"
import script from "./document-category-list-modal.vue?vue&type=script&lang=js"
export * from "./document-category-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__